import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { RAJ_MARKETING_URL } from "./rajMarketingDomain.ts";

/** Presentation only: native menu, page metadata and section navigation. */
export function useRajLanding() {
  const menuRef = useRef<HTMLDetailsElement>(null);
  const { hash, key } = useLocation();

  useEffect(function () {
    const oldTitle = document.title;
    const description = document.querySelector('meta[name="description"]');
    const viewport = document.querySelector('meta[name="viewport"]');
    const oldDescription = description?.getAttribute("content") ?? "";
    const oldViewport = viewport?.getAttribute("content") ?? "";
    const existingCanonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    const canonical = existingCanonical ?? document.createElement("link");
    const oldCanonicalHref = existingCanonical?.getAttribute("href");
    canonical.rel = "canonical";
    canonical.href = RAJ_MARKETING_URL;
    if (!existingCanonical) document.head.appendChild(canonical);
    document.title = "رج | نرم‌افزارهای تخصصی صنعت فرش";
    description?.setAttribute("content", "رج؛ راهکارهای طراحی، تولید، انبارداری و پرتال نمایندگان، همراه با مدیریت ارتباط با مشتری، دبیرخانه، درایو و تقویم. درخواست دمو: ۰۲۱۹۱۰۹۹۱۵۹");
    viewport?.setAttribute("content", "width=device-width, initial-scale=1, viewport-fit=cover");

    function closeMenu(event: MouseEvent) {
      const menu = menuRef.current;
      if (!menu || !(event.target instanceof Element)) return;
      if (!menu.contains(event.target) || event.target.closest("nav a")) menu.open = false;
    }

    function escapeMenu(event: KeyboardEvent) {
      if (event.key === "Escape" && menuRef.current?.open) {
        menuRef.current.open = false;
        menuRef.current.querySelector("summary")?.focus();
      }
    }

    document.addEventListener("click", closeMenu);
    document.addEventListener("keydown", escapeMenu);
    return function () {
      document.removeEventListener("click", closeMenu);
      document.removeEventListener("keydown", escapeMenu);
      document.title = oldTitle;
      description?.setAttribute("content", oldDescription);
      viewport?.setAttribute("content", oldViewport);
      if (!existingCanonical) canonical.remove();
      else if (oldCanonicalHref == null) canonical.removeAttribute("href");
      else canonical.setAttribute("href", oldCanonicalHref);
    };
  }, []);

  useEffect(function () {
    const target = document.getElementById(hash.slice(1));
    if (!target || !target.closest(".raj-landing")) return;
    target.scrollIntoView({
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
      block: "start",
    });
    target.focus({ preventScroll: true });
  }, [hash, key]);

  return menuRef;
}
